
export const loginConstant = {
    usernameError : 'Please enter username',
    usernameLabel : 'User Name',
    passwordError : 'Please enter password',
    passwordLabel : 'Password',
    loginButtonLabel : 'Login'
}

export const loginApiConstants = {
    login : '/auth/login'
}